export default {
  CONVULSE: 'convulse', // ชักกระตุก
  WEAK: 'weak',
  PARALYSIS: 'paralysis' // อัมพฤกษ์
}
